import PropTypes from 'prop-types';
export const spacerPropTypes = {
  /**
   * Variant
   */
  variant: PropTypes.oneOf(['sm', 'md'])
};